import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';

import { useLocation } from 'react-router-dom';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const UPIGatewayTransaction = () => {
    const formRef = useRef(null);

    const location = useLocation();
    const CallBackURL = location.state.CallBackURL;
    const FormActionURL = location.state.FormActionURL;
    const Hash = location.state.Hash;
    const OrderID = location.state.OrderID;
    const VPA = location.state.VPA;
    const Amount = location.state.Amount;
    const Name = location.state.Name;
    const Email = location.state.Email;
    const ContactNumber = location.state.ContactNumber;
    const Key = location.state.Key;
    const RedirectURL = location.state.RedirectURL;
    const initialValues = {
        CallBackURL: CallBackURL,
        Hash: Hash,
        FormActionURL: FormActionURL,
        OrderID: OrderID,
        VPA: VPA,
        Amount: Amount,
        Name: Name,
        Email: Email,
        ContactNumber: ContactNumber,
        Key: Key,
        RedirectURL: RedirectURL
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        formRef.current.submit();
    }, []);
    return (
        <CustomContainer>
            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.FormActionURL}
            >
                <input type="hidden" name="client_vpa" value={FormObj.VPA} />
                <input type="hidden" name="amount" value={FormObj.Amount} />

                <input type="hidden" name="client_name" value={FormObj.Name} />
                <input
                    type="hidden"
                    name="client_email"
                    value={FormObj.Email}
                />
                <input
                    type="hidden"
                    name="client_mobile"
                    value={FormObj.ContactNumber}
                />

                <input type="hidden" name="key" value={FormObj.Key} />
                <input type="hidden" name="p_info" value="RECHARGE" />
                <input
                    type="hidden"
                    name="client_txn_id"
                    value={FormObj.OrderID}
                />
                <input type="hidden" name="udf1" value="" />
                <input type="hidden" name="udf2" value="" />
                <input type="hidden" name="udf3" value="" />

                <input type="hidden" name="hash" value={FormObj.Hash} />
                <input
                    type="hidden"
                    name="redirect_url"
                    value={FormObj.RedirectURL}
                />
                <input type="submit" value="Redirect" />
            </form>
        </CustomContainer>
    );
};
